module.exports = __webpack_public_path__ + "img/feature-tile-icon-05.60101632.svg";